var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmoothArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1317 19.6687C56.7598 17.9816 55.6091 16.5101 54.3982 15.0857C53.5973 14.1482 53.5081 13.1996 54.4304 12.399C55.2625 11.6765 56.1407 12.0411 56.8393 12.7545C60.1703 16.1445 62.5951 20.0721 63.7415 24.7095C64.2362 26.6951 62.9407 27.4756 61.3049 27.5784C56.4949 27.8817 51.8058 26.8869 47.1329 25.9376C46.1419 25.7403 45.4451 25.1185 45.6858 24.0045C45.9568 22.7278 46.9428 22.5188 48.0588 22.7045C50.6249 23.1241 53.1912 23.559 56.2635 24.0756C55.2947 22.3775 54.0738 21.6836 52.8991 21.0041C42.5401 15.0155 31.8501 15.2888 21.101 19.6673C15.1444 22.0927 9.9677 25.7831 5.76342 30.7375C5.01992 31.6141 4.29657 33.3519 2.89002 32.2308C1.50826 31.1276 2.98926 29.995 3.69874 29.0978C16.9673 12.3237 42.7908 7.9393 57.0267 19.5775C57.1635 19.6909 57.4585 19.6209 58.1257 19.6718L58.1317 19.6687Z",
    fill: "#D7CCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_3057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3218,
    height: 58.22,
    fill: "white",
    transform: "translate(13.6309 53.0264) rotate(-117.702)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothArrowRight);
export default __webpack_public_path__ + "static/media/SmoothArrowRight.a1e298ef1f37456a31d2992773141493.svg";
export { ForwardRef as ReactComponent };